import { useNavigate } from 'react-router-dom';
import type { BlogPost } from '@/mocks/blogData';

interface BlogCardProps {
  post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
  const navigate = useNavigate();

  return (
    <article className="group cursor-pointer" onClick={() => navigate(`/blog/${post.slug}`)}>
      <div className="relative overflow-hidden rounded-lg mb-4 aspect-[16/10]">
        <img
          src={post.coverImage}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {post.featured && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-champagne-gold text-royal-navy text-xs font-semibold border border-champagne-gold/50">
            Featured
          </span>
        )}
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-3 text-xs text-taupe-grey">
          <span className="px-2 py-0.5 rounded-full bg-royal-navy/30 text-silver-grey">{post.category}</span>
          <span>{post.readTime}</span>
          <span>{post.publishedAt}</span>
        </div>
        <h3 className="text-lg font-heading font-semibold text-warm-white group-hover:text-champagne-gold transition-colors duration-300 leading-snug">
          {post.title}
        </h3>
        <p className="text-silver-grey text-sm leading-relaxed line-clamp-2">
          {post.excerpt}
        </p>
        <div className="flex items-center flex-wrap gap-1.5 pt-1">
          {post.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium border border-background-200/70"
            >
              #{tag}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-1 text-champagne-gold text-sm font-medium pt-1">
          Read more
          <i className="ri-arrow-right-line text-xs" />
        </div>
      </div>
    </article>
  );
}